import Vue from 'vue';
import linkDynamic from '@editor/droplets/_bubble-options/components/link-dynamic';

export default Vue.component('edit-project-details', {
  template: require('./template.html'),
  name: 'edit-project-details',
  props: ['droplet', 'show-edit-bubble', 'profile', 'dynamic-item'],
  components: {
    linkDynamic,
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/project-details/components/_edit-options/index.js